import type { CheckmarkProps } from '@chakra-ui/react';
import { Checkmark as CheckBox } from '@chakra-ui/react';
import { useMemo } from 'react';

const sizeMemo = {
  xs: '0.875rem',
  sm: '1.125rem',
  md: '1.375rem',
  lg: '1.625rem',
};
export const Checkmark = (props: CheckmarkProps) => {
  const { size } = props;

  const width = useMemo(() => {
    return sizeMemo[(size || 'sm') as keyof typeof sizeMemo];
  }, [size]);
  return (
    <CheckBox
      {...props}
      css={{
        w: width,
        h: width,
        border: '1px solid',
        borderColor: 'border.muted',
        color: 'white',
        '&[data-state="checked"]': {
          bg: 'brand',
        },
        '&[data-disabled]': {
          bg: 'grey.50',
          color: 'white',
        },
        '&[data-disabled]&[data-state="checked"]': {
          bg: 'brand.30',
          color: 'white',
        },
      }}
    />
  );
};
